"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentDispositionType = exports.EntityTypeStatusTransitionRule = exports.ActionStatusTransitionRule = exports.NumberFormatConfigSetting = exports.BillingFrequencyUnit = exports.TranslatableEntity = exports.TranslatableFieldNamespace = exports.LeadPaymentMethodType = exports.Language = exports.Currency = exports.AccountType = exports.PbmProduct = exports.InvoiceStatus = exports.PaymentMethodType = exports.CoverageType = exports.ClaimStatus = exports.LeadStatus = exports.ProductVersionStatus = exports.Title = exports.CamundaEventType = exports.PolicyTerminationReason = exports.PolicyStatus = exports.TransactionStatus = exports.PremiumFormulaVisibilities = exports.PremiumFormulaItemTypes = exports.PremiumFormulaUnits = exports.PremiumFormulaTypes = exports.TenantConfig = exports.AccountConfig = exports.CustomFieldEntity = exports.InvoiceType = exports.DocumentEntityType = exports.CreditTypes = exports.DocumentRequester = exports.ContentType = exports.InsuranceProvider = exports.BillingMethods = exports.InsuredObjectType = exports.RenewalFrequency = exports.DurationUnits = exports.DateTimeOperations = exports.DateTimeOffsets = exports.DateTimeIdentifierKeys = exports.DateTimePlaceHolders = exports.CustomProductFieldsDataTypes = exports.BasicProductFieldsDataTypes = exports.RegistrationType = exports.SfClass = exports.GdvLicensePlateType = exports.GdvVehicleUsage = exports.GdvVehicleType = exports.ConnectionToken = exports.ApiErrorDesc = exports.CognitoTokenFields = exports.NodeEnvs = exports.TenantRoles = exports.ServiceTiers = exports.ServiceEventType = exports.EmilServices = void 0;
var EmilServices;
(function (EmilServices) {
    EmilServices["AccountService"] = "accountservice";
    EmilServices["AuthService"] = "authservice";
    EmilServices["DocumentService"] = "documentservice";
    EmilServices["InsuranceService"] = "insuranceservice";
    EmilServices["PublicApi"] = "publicapi";
    EmilServices["TenantService"] = "tenantservice";
    EmilServices["TicketingService"] = "ticketingservice";
    EmilServices["BillingService"] = "billingservice";
    EmilServices["GdvService"] = "gdvservice";
    EmilServices["ProcessManager"] = "processmanager";
    EmilServices["PaymentService"] = "paymentservice";
    EmilServices["NotificationService"] = "notificationservice";
    EmilServices["PbmService"] = "pbmservice";
})(EmilServices = exports.EmilServices || (exports.EmilServices = {}));
var ServiceEventType;
(function (ServiceEventType) {
    ServiceEventType["AccountUpdated"] = "ACCOUNT_UPDATED";
    ServiceEventType["LeadCreated"] = "LEAD_CREATED";
    ServiceEventType["PolicyCreated"] = "POLICY_CREATED";
    ServiceEventType["PolicyUpdated"] = "POLICY_UPDATED";
    ServiceEventType["PolicyStarted"] = "POLICY_STARTED";
    ServiceEventType["PolicyTerminated"] = "POLICY_TERMINATED";
    ServiceEventType["PolicyWithdrawn"] = "POLICY_WITHDRAWN";
    ServiceEventType["PolicySuspended"] = "POLICY_SUSPENDED";
    ServiceEventType["PolicyActivated"] = "POLICY_ACTIVATED";
    ServiceEventType["PolicyDraftVersionCreated"] = "POLICY_DRAFT_VERSION_CREATED";
    ServiceEventType["PaymentStatusChanged"] = "PAYMENT_STATUS_CHANGED";
    ServiceEventType["PaymentReminderTriggered"] = "PAYMENT_REMINDER_TRIGGERED";
    ServiceEventType["RecurringInvoiceTriggered"] = "RECURRING_INVOICE_TRIGGERED";
    ServiceEventType["ClaimCreated"] = "CLAIM_CREATED";
    ServiceEventType["ClaimUpdated"] = "CLAIM_UPDATED";
    ServiceEventType["DueInvoiceTriggered"] = "DUE_INVOICE_TRIGGERED";
    ServiceEventType["VbaCreationTriggered"] = "VBA_CREATION_TRIGGERED";
    ServiceEventType["VbuCreationTriggered"] = "VBU_CREATION_TRIGGERED";
    ServiceEventType["GdvMessageReceived"] = "GDV_MESSAGE_RECEIVED";
    ServiceEventType["ClaimRegulationCreated"] = "CLAIM_REGULATION_CREATED";
    ServiceEventType["ClaimRegulationUpdated"] = "CLAIM_REGULATION_UPDATED";
})(ServiceEventType = exports.ServiceEventType || (exports.ServiceEventType = {}));
var ServiceTiers;
(function (ServiceTiers) {
    ServiceTiers["Gold"] = "Gold";
    ServiceTiers["Platinum"] = "Platinum";
    ServiceTiers["Diamond"] = "Diamond";
})(ServiceTiers = exports.ServiceTiers || (exports.ServiceTiers = {}));
var TenantRoles;
(function (TenantRoles) {
    TenantRoles["Admin"] = "admin";
    TenantRoles["User"] = "user";
    TenantRoles["Customer"] = "customer";
})(TenantRoles = exports.TenantRoles || (exports.TenantRoles = {}));
var NodeEnvs;
(function (NodeEnvs) {
    NodeEnvs["Local"] = "local";
    NodeEnvs["Development"] = "development";
    NodeEnvs["Testing"] = "testing";
    NodeEnvs["Staging"] = "staging";
    NodeEnvs["Performance"] = "performance";
    NodeEnvs["Production"] = "production";
})(NodeEnvs = exports.NodeEnvs || (exports.NodeEnvs = {}));
var CognitoTokenFields;
(function (CognitoTokenFields) {
    CognitoTokenFields["TenantId"] = "custom:tenant_id";
    CognitoTokenFields["TenantSlug"] = "custom:tenant_slug";
    CognitoTokenFields["TenantHierarchy"] = "custom:tenant_hierarchy";
    CognitoTokenFields["Username"] = "cognito:username";
    CognitoTokenFields["Role"] = "custom:role";
    CognitoTokenFields["Code"] = "custom:code";
    CognitoTokenFields["GivenName"] = "given_name";
    CognitoTokenFields["FamilyName"] = "family_name";
    CognitoTokenFields["Email"] = "email";
    CognitoTokenFields["Iss"] = "iss";
    CognitoTokenFields["Sub"] = "sub";
    CognitoTokenFields["Identities"] = "identities";
})(CognitoTokenFields = exports.CognitoTokenFields || (exports.CognitoTokenFields = {}));
var ApiErrorDesc;
(function (ApiErrorDesc) {
    ApiErrorDesc["Unauthorized"] = "You are not authorized to make the request. Hint: check that the request token is valid";
    ApiErrorDesc["NotFound"] = "An entity specified in your request was not found";
    ApiErrorDesc["BadRequest"] = "Your request does not match what the server expects. Hint: compare your request payload with the provided schema";
})(ApiErrorDesc = exports.ApiErrorDesc || (exports.ApiErrorDesc = {}));
var ConnectionToken;
(function (ConnectionToken) {
    ConnectionToken["SystemDatabaseConnection"] = "SYSTEM_DATABASE_CONNECTION";
    ConnectionToken["TenantDatabaseConnection"] = "TENANT_DATABASE_CONNECTION";
})(ConnectionToken = exports.ConnectionToken || (exports.ConnectionToken = {}));
var GdvVehicleType;
(function (GdvVehicleType) {
    GdvVehicleType["LightVehicle"] = "1";
    GdvVehicleType["PassengerCar"] = "2";
    GdvVehicleType["Bus"] = "3";
    GdvVehicleType["Truck"] = "4";
    GdvVehicleType["Tractor"] = "5";
    GdvVehicleType["SelfDrivingAgriculturalMachine"] = "6";
    GdvVehicleType["Trailer"] = "7";
    GdvVehicleType["OtherMotorVehicle"] = "8";
})(GdvVehicleType = exports.GdvVehicleType || (exports.GdvVehicleType = {}));
var GdvVehicleUsage;
(function (GdvVehicleUsage) {
    GdvVehicleUsage["VehicleForDisabledPerson"] = "B";
    GdvVehicleUsage["Ambulance"] = "K";
    GdvVehicleUsage["PublicBus"] = "K";
    GdvVehicleUsage["RentalVehicle"] = "M";
    GdvVehicleUsage["SelfDriveRentalVehicle"] = "S";
    GdvVehicleUsage["Taxi"] = "T";
    GdvVehicleUsage["OtherSpecialUse"] = "X";
    GdvVehicleUsage["WithoutSpecialUse"] = "O";
    GdvVehicleUsage["BusForDisabledPerson"] = "C";
    GdvVehicleUsage["RentalVehicleForDisabledPerson"] = "D";
    GdvVehicleUsage["SelfDriveRentalAmbulance"] = "E";
    GdvVehicleUsage["SelfDriveRentalTaxi"] = "G";
})(GdvVehicleUsage = exports.GdvVehicleUsage || (exports.GdvVehicleUsage = {}));
var GdvLicensePlateType;
(function (GdvLicensePlateType) {
    GdvLicensePlateType["Exported"] = "A";
    GdvLicensePlateType["Government"] = "B";
    GdvLicensePlateType["GovernmentSeasonal"] = "BS";
    GdvLicensePlateType["Dealers"] = "R";
    GdvLicensePlateType["ShortTime"] = "RK";
    GdvLicensePlateType["Insurance"] = "V";
    GdvLicensePlateType["DealersInsurance"] = "VR";
    GdvLicensePlateType["Official"] = "Z";
    GdvLicensePlateType["OfficialSeasonal"] = "ZS";
})(GdvLicensePlateType = exports.GdvLicensePlateType || (exports.GdvLicensePlateType = {}));
var SfClass;
(function (SfClass) {
    SfClass["SF0"] = "0";
    SfClass["M"] = "M";
    SfClass["S"] = "S";
    SfClass["SF1/2"] = "SF1/2";
    SfClass["SF1"] = "SF1";
    SfClass["SF2"] = "SF2";
    SfClass["SF3"] = "SF3";
    SfClass["SF4"] = "SF4";
    SfClass["SF5"] = "SF5";
    SfClass["SF6"] = "SF6";
    SfClass["SF7"] = "SF7";
    SfClass["SF8"] = "SF8";
    SfClass["SF9"] = "SF9";
    SfClass["SF10"] = "SF10";
    SfClass["SF11"] = "SF11";
    SfClass["SF12"] = "SF12";
    SfClass["SF13"] = "SF13";
    SfClass["SF14"] = "SF14";
    SfClass["SF15"] = "SF15";
    SfClass["SF16"] = "SF16";
    SfClass["SF17"] = "SF17";
    SfClass["SF18"] = "SF18";
    SfClass["SF19"] = "SF19";
    SfClass["SF20"] = "SF20";
    SfClass["SF21"] = "SF21";
    SfClass["SF22"] = "SF22";
    SfClass["SF23"] = "SF23";
    SfClass["SF24"] = "SF24";
    SfClass["SF25"] = "SF25";
    SfClass["SF26"] = "SF26";
    SfClass["SF27"] = "SF27";
    SfClass["SF28"] = "SF28";
    SfClass["SF29"] = "SF29";
    SfClass["SF30"] = "SF30";
    SfClass["SF31"] = "SF31";
    SfClass["SF32"] = "SF32";
    SfClass["SF33"] = "SF33";
    SfClass["SF34"] = "SF34";
    SfClass["SF35"] = "SF35";
    SfClass["SF36"] = "SF36";
    SfClass["SF37"] = "SF37";
    SfClass["SF38"] = "SF38";
    SfClass["SF39"] = "SF39";
    SfClass["SF40"] = "SF40";
    SfClass["SF41"] = "SF41";
    SfClass["SF42"] = "SF42";
    SfClass["SF43"] = "SF43";
    SfClass["SF44"] = "SF44";
})(SfClass = exports.SfClass || (exports.SfClass = {}));
var RegistrationType;
(function (RegistrationType) {
    RegistrationType["ChangeOfInsurance"] = "Versichererwechsel";
    RegistrationType["SecondCar"] = "Zweitwagen";
    RegistrationType["DifferentCar"] = "Neuzulassung";
    RegistrationType["AdditionalCar"] = "Weiteres_Fahrzeug";
    RegistrationType["DifferentInsuredPerson"] = "Anderer_Versicherungsnehmer";
    RegistrationType["TakeOver"] = "Betriebsu\u0308bernahme";
    RegistrationType["DamageClassFile"] = "Hinweis_der_Malus-Datei";
})(RegistrationType = exports.RegistrationType || (exports.RegistrationType = {}));
var BasicProductFieldsDataTypes;
(function (BasicProductFieldsDataTypes) {
    BasicProductFieldsDataTypes["Number"] = "number";
    BasicProductFieldsDataTypes["Boolean"] = "boolean";
    BasicProductFieldsDataTypes["String"] = "string";
})(BasicProductFieldsDataTypes = exports.BasicProductFieldsDataTypes || (exports.BasicProductFieldsDataTypes = {}));
var CustomProductFieldsDataTypes;
(function (CustomProductFieldsDataTypes) {
    CustomProductFieldsDataTypes["DateTime"] = "dateTime";
    CustomProductFieldsDataTypes["Email"] = "email";
    CustomProductFieldsDataTypes["DurationUnit"] = "durationUnit";
    CustomProductFieldsDataTypes["RenewalFrequency"] = "renewalFrequency";
    CustomProductFieldsDataTypes["SFClass"] = "sfClass";
    CustomProductFieldsDataTypes["LicensePlateRegion"] = "licensePlateRegion";
    CustomProductFieldsDataTypes["LicensePlateLetters"] = "licensePlateLetters";
    CustomProductFieldsDataTypes["LicensePlateNumbers"] = "licensePlateNumbers";
    CustomProductFieldsDataTypes["VehicleType"] = "vehicleType";
    CustomProductFieldsDataTypes["VehicleUsage"] = "vehicleUsage";
    CustomProductFieldsDataTypes["LicensePlateType"] = "licensePlateType";
    CustomProductFieldsDataTypes["VehicleRegistrationType"] = "registrationType";
})(CustomProductFieldsDataTypes = exports.CustomProductFieldsDataTypes || (exports.CustomProductFieldsDataTypes = {}));
var DateTimePlaceHolders;
(function (DateTimePlaceHolders) {
    DateTimePlaceHolders["Today"] = "today";
    DateTimePlaceHolders["Tomorrow"] = "tomorrow";
    DateTimePlaceHolders["StartNextMonth"] = "startNextMonth";
    DateTimePlaceHolders["StartNextYear"] = "startNextYear";
})(DateTimePlaceHolders = exports.DateTimePlaceHolders || (exports.DateTimePlaceHolders = {}));
var DateTimeIdentifierKeys;
(function (DateTimeIdentifierKeys) {
    DateTimeIdentifierKeys["Templated"] = "templated";
    DateTimeIdentifierKeys["Evaluated"] = "evaluated";
})(DateTimeIdentifierKeys = exports.DateTimeIdentifierKeys || (exports.DateTimeIdentifierKeys = {}));
var DateTimeOffsets;
(function (DateTimeOffsets) {
    DateTimeOffsets["Day"] = "d";
    DateTimeOffsets["Month"] = "m";
    DateTimeOffsets["Year"] = "y";
})(DateTimeOffsets = exports.DateTimeOffsets || (exports.DateTimeOffsets = {}));
var DateTimeOperations;
(function (DateTimeOperations) {
    DateTimeOperations["Add"] = "+";
    DateTimeOperations["Subtract"] = "-";
})(DateTimeOperations = exports.DateTimeOperations || (exports.DateTimeOperations = {}));
var DurationUnits;
(function (DurationUnits) {
    DurationUnits["Second"] = "second";
    DurationUnits["Minute"] = "minute";
    DurationUnits["Hour"] = "hour";
    DurationUnits["Day"] = "day";
    DurationUnits["Week"] = "week";
    DurationUnits["Month"] = "month";
    DurationUnits["Year"] = "year";
})(DurationUnits = exports.DurationUnits || (exports.DurationUnits = {}));
var RenewalFrequency;
(function (RenewalFrequency) {
    RenewalFrequency[RenewalFrequency["Auto"] = -1] = "Auto";
    RenewalFrequency[RenewalFrequency["NoRenewal"] = 0] = "NoRenewal";
})(RenewalFrequency = exports.RenewalFrequency || (exports.RenewalFrequency = {}));
var InsuredObjectType;
(function (InsuredObjectType) {
    InsuredObjectType["Default"] = "default";
    InsuredObjectType["Car"] = "car";
    InsuredObjectType["TPL"] = "tpl";
    InsuredObjectType["Custom"] = "custom";
    InsuredObjectType["Motorbike"] = "motorbike";
    InsuredObjectType["Moped"] = "moped";
    InsuredObjectType["Bike"] = "bike";
    InsuredObjectType["HomeContents"] = "homeContents";
    InsuredObjectType["LegalProtection"] = "legalProtection";
    InsuredObjectType["Accident"] = "accident";
    InsuredObjectType["Travel"] = "travel";
    InsuredObjectType["Device"] = "device";
})(InsuredObjectType = exports.InsuredObjectType || (exports.InsuredObjectType = {}));
var BillingMethods;
(function (BillingMethods) {
    BillingMethods["Aliquot"] = "aliquot";
    BillingMethods["PolicyStartDate"] = "policyStartDate";
    BillingMethods["OneTimePayment"] = "oneTimePayment";
})(BillingMethods = exports.BillingMethods || (exports.BillingMethods = {}));
var InsuranceProvider;
(function (InsuranceProvider) {
    InsuranceProvider["Squarelife"] = "squarelife";
    InsuranceProvider["Janitos"] = "janitos";
})(InsuranceProvider = exports.InsuranceProvider || (exports.InsuranceProvider = {}));
var ContentType;
(function (ContentType) {
    ContentType["PDF"] = "pdf";
    ContentType["JPG"] = "jpg";
    ContentType["PNG"] = "png";
    ContentType["GZ"] = "gz";
    ContentType["CSV"] = "csv";
    ContentType["DOC"] = "doc";
    ContentType["DOCX"] = "docx";
    ContentType["HTML"] = "html";
    ContentType["JSON"] = "json";
    ContentType["XML"] = "xml";
    ContentType["TXT"] = "txt";
    ContentType["ZIP"] = "zip";
    ContentType["TAR"] = "tar";
    ContentType["RAR"] = "rar";
    ContentType["MP4"] = "MP4";
    ContentType["MOV"] = "MOV";
    ContentType["WMV"] = "WMV";
    ContentType["AVI"] = "AVI";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
var DocumentRequester;
(function (DocumentRequester) {
    DocumentRequester["AccountService"] = "accountservice";
    DocumentRequester["InsuranceService"] = "insuranceservice";
    DocumentRequester["BillingService"] = "billingservice";
    DocumentRequester["TenantService"] = "tenantservice";
    DocumentRequester["BookingFunnel"] = "bookingFunnel";
    DocumentRequester["Publicapi"] = "publicapi";
    DocumentRequester["Admin"] = "admin";
    DocumentRequester["ClaimService"] = "claimservice";
    DocumentRequester["CustomerService"] = "customerservice";
    DocumentRequester["NotificationService"] = "notificationservice";
    DocumentRequester["PaymentService"] = "paymentservice";
    DocumentRequester["Processmanager"] = "processmanager";
    DocumentRequester["GdvService"] = "gdvservice";
    DocumentRequester["DocumentService"] = "documentservice";
})(DocumentRequester = exports.DocumentRequester || (exports.DocumentRequester = {}));
var CreditTypes;
(function (CreditTypes) {
    CreditTypes["Fixed"] = "fixed";
    CreditTypes["Variable"] = "variable";
})(CreditTypes = exports.CreditTypes || (exports.CreditTypes = {}));
var DocumentEntityType;
(function (DocumentEntityType) {
    DocumentEntityType["PolicyApplication"] = "policy_application";
    DocumentEntityType["PolicyContract"] = "policy_contract";
    DocumentEntityType["PolicyAddendum"] = "policy_addendum";
    DocumentEntityType["InitialInvoice"] = "initial_invoice";
    DocumentEntityType["CorrectionInvoice"] = "correction_invoice";
    DocumentEntityType["RecurringInvoice"] = "recurring_invoice";
    DocumentEntityType["SepaMandate"] = "sepa_mandate";
    DocumentEntityType["Static"] = "static";
})(DocumentEntityType = exports.DocumentEntityType || (exports.DocumentEntityType = {}));
var InvoiceType;
(function (InvoiceType) {
    InvoiceType["Initial"] = "initial";
    InvoiceType["Recurring"] = "recurring";
    InvoiceType["Correction"] = "correction";
    InvoiceType["Estimated"] = "estimated";
    InvoiceType["Penalty"] = "penalty";
    InvoiceType["Other"] = "other";
    InvoiceType["Withdraw"] = "withdraw";
    InvoiceType["Final"] = "final";
})(InvoiceType = exports.InvoiceType || (exports.InvoiceType = {}));
var CustomFieldEntity;
(function (CustomFieldEntity) {
    CustomFieldEntity["Account"] = "account";
    CustomFieldEntity["Claim"] = "claim";
    CustomFieldEntity["Invoice"] = "invoice";
    CustomFieldEntity["Payment"] = "payment";
    CustomFieldEntity["Organization"] = "organization";
})(CustomFieldEntity = exports.CustomFieldEntity || (exports.CustomFieldEntity = {}));
var AccountConfig;
(function (AccountConfig) {
    AccountConfig["AllowMultiplePolicy"] = "account:allowMultiplePolicies";
})(AccountConfig = exports.AccountConfig || (exports.AccountConfig = {}));
var TenantConfig;
(function (TenantConfig) {
    TenantConfig["WorkflowConfig"] = "workflow_config";
    TenantConfig["SenderEmail"] = "sender_email";
    TenantConfig["ActivePsp"] = "active_psp";
    TenantConfig["TaxConfig"] = "tax_config";
    TenantConfig["StripeConfig"] = "stripe_config";
    TenantConfig["BraintreeConfig"] = "braintree_config";
    TenantConfig["DocumentBlackList"] = "document_black_list";
    TenantConfig["JanitosConfig"] = "janitos_config";
    TenantConfig["SquarelifeConfig"] = "squarelife_config";
    TenantConfig["BfCustomCss"] = "bf_custom_css";
})(TenantConfig = exports.TenantConfig || (exports.TenantConfig = {}));
var PremiumFormulaTypes;
(function (PremiumFormulaTypes) {
    PremiumFormulaTypes["Time"] = "time";
})(PremiumFormulaTypes = exports.PremiumFormulaTypes || (exports.PremiumFormulaTypes = {}));
var PremiumFormulaUnits;
(function (PremiumFormulaUnits) {
    PremiumFormulaUnits["Day"] = "day";
    PremiumFormulaUnits["Week"] = "week";
    PremiumFormulaUnits["Month"] = "month";
    PremiumFormulaUnits["Quarter"] = "quarter";
    PremiumFormulaUnits["Year"] = "year";
    PremiumFormulaUnits["OneTimePayment"] = "oneTimePayment";
})(PremiumFormulaUnits = exports.PremiumFormulaUnits || (exports.PremiumFormulaUnits = {}));
var PremiumFormulaItemTypes;
(function (PremiumFormulaItemTypes) {
    PremiumFormulaItemTypes["Netto"] = "netto";
    PremiumFormulaItemTypes["Commission"] = "commission";
    PremiumFormulaItemTypes["Tax"] = "tax";
    PremiumFormulaItemTypes["Discount"] = "discount";
    PremiumFormulaItemTypes["Brutto"] = "brutto";
    PremiumFormulaItemTypes["Other"] = "other";
})(PremiumFormulaItemTypes = exports.PremiumFormulaItemTypes || (exports.PremiumFormulaItemTypes = {}));
var PremiumFormulaVisibilities;
(function (PremiumFormulaVisibilities) {
    PremiumFormulaVisibilities["Public"] = "public";
    PremiumFormulaVisibilities["Internal"] = "internal";
})(PremiumFormulaVisibilities = exports.PremiumFormulaVisibilities || (exports.PremiumFormulaVisibilities = {}));
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["Succeeded"] = "succeeded";
    TransactionStatus["Pending"] = "pending";
    TransactionStatus["Failed"] = "failed";
    TransactionStatus["Disputed"] = "disputed";
    TransactionStatus["Refunded"] = "refunded";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
var PolicyStatus;
(function (PolicyStatus) {
    PolicyStatus["ACTIVE"] = "ACTIVE";
    PolicyStatus["WITHDRAWN"] = "WITHDRAWN";
    PolicyStatus["TERMINATED"] = "TERMINATED";
    PolicyStatus["SUSPENDED"] = "SUSPENDED";
    PolicyStatus["PENDING"] = "PENDING";
})(PolicyStatus = exports.PolicyStatus || (exports.PolicyStatus = {}));
var PolicyTerminationReason;
(function (PolicyTerminationReason) {
    PolicyTerminationReason["TerminationAtRenewal"] = "termination_at_renewal";
    PolicyTerminationReason["TerminationAfterClaim"] = "termination_after_claim";
    PolicyTerminationReason["TerminationDueToUnderwriting"] = "termination_due_to_underwriting";
    PolicyTerminationReason["TerminationDueToDefaultOfInitialPremium"] = "termination_due_to_default_of_initial_premium";
    PolicyTerminationReason["TerminationDueToDefaultOfSubsequentPremium"] = "termination_due_to_default_of_subsequent_premium";
    PolicyTerminationReason["TerminationDueToDoubleInsurance"] = "termination_due_to_double_insurance";
    PolicyTerminationReason["TerminationDueToLossOfRisk"] = "termination_due_to_loss_of_risk";
    PolicyTerminationReason["TerminationDueToBreachOfDuty"] = "termination_due_to_breach_of_duty";
    PolicyTerminationReason["TerminationDueToExpiry"] = "termination_due_to_expiry";
    PolicyTerminationReason["Other"] = "other";
})(PolicyTerminationReason = exports.PolicyTerminationReason || (exports.PolicyTerminationReason = {}));
var CamundaEventType;
(function (CamundaEventType) {
    CamundaEventType["EndEvent"] = "end_event";
})(CamundaEventType = exports.CamundaEventType || (exports.CamundaEventType = {}));
var Title;
(function (Title) {
    Title["None"] = "";
    Title["Doctor"] = "Dr.";
    Title["MedicineDoctor"] = "Dr. med.";
    Title["Professor"] = "Prof. Dr. med.";
})(Title = exports.Title || (exports.Title = {}));
var ProductVersionStatus;
(function (ProductVersionStatus) {
    ProductVersionStatus["Draft"] = "draft";
    ProductVersionStatus["Active"] = "active";
    ProductVersionStatus["Passive"] = "passive";
    ProductVersionStatus["Archived"] = "archived";
})(ProductVersionStatus = exports.ProductVersionStatus || (exports.ProductVersionStatus = {}));
var LeadStatus;
(function (LeadStatus) {
    LeadStatus["Created"] = "created";
    LeadStatus["Approved"] = "approved";
    LeadStatus["Activated"] = "activated";
    LeadStatus["Declined"] = "declined";
})(LeadStatus = exports.LeadStatus || (exports.LeadStatus = {}));
var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["Reported"] = "reported";
    ClaimStatus["Open"] = "open";
    ClaimStatus["InProgress"] = "in_progress";
    ClaimStatus["Closed"] = "closed";
    ClaimStatus["Rejected"] = "rejected";
})(ClaimStatus = exports.ClaimStatus || (exports.ClaimStatus = {}));
var CoverageType;
(function (CoverageType) {
    CoverageType["KH"] = "kh";
    CoverageType["VK"] = "vk";
    CoverageType["TK"] = "tk";
})(CoverageType = exports.CoverageType || (exports.CoverageType = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["Paypal"] = "paypal";
    PaymentMethodType["CreditCard"] = "credit_card";
    PaymentMethodType["SepaDebit"] = "sepa_debit";
    PaymentMethodType["Sofort"] = "sofort";
    PaymentMethodType["Card"] = "card";
    PaymentMethodType["GiroPay"] = "giropay";
    PaymentMethodType["Klarna"] = "klarna";
    PaymentMethodType["Visa"] = "visa";
    PaymentMethodType["ApplePay"] = "apple_pay";
    PaymentMethodType["AndroidPay"] = "android_pay";
    PaymentMethodType["SamsungPay"] = "samsung_pay";
    PaymentMethodType["Venmo"] = "venmo";
    PaymentMethodType["Masterpass"] = "masterpass";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["Open"] = "open";
    InvoiceStatus["Paid"] = "paid";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var PbmProduct;
(function (PbmProduct) {
    PbmProduct["Car"] = "car";
    PbmProduct["Homeowner"] = "homeowner";
    PbmProduct["Household"] = "household";
    PbmProduct["PrivateLiability"] = "privateLiability";
})(PbmProduct = exports.PbmProduct || (exports.PbmProduct = {}));
var AccountType;
(function (AccountType) {
    AccountType["Person"] = "person";
    AccountType["Organization"] = "org";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
var Currency;
(function (Currency) {
    Currency["EURO"] = "EUR";
    Currency["DOLLAR"] = "USD";
    Currency["POUND"] = "GBP";
    Currency["SWISS_FRANC"] = "CHF";
    Currency["ZLOTY"] = "PLN";
    Currency["AUSTRALIAN_DOLLAR"] = "AUD";
    Currency["CANADIAN_DOLLAR"] = "CAD";
    Currency["DANISH_KRONE"] = "DDK";
    Currency["FORINT"] = "HUF";
    Currency["NORWEGIAN_KRONE"] = "NOK";
    Currency["SWEDISH_KRONE"] = "SEK";
})(Currency = exports.Currency || (exports.Currency = {}));
var Language;
(function (Language) {
    Language["German"] = "German";
    Language["English"] = "English";
    Language["Polish"] = "Polish";
    Language["French"] = "French";
    Language["Italian"] = "Italian";
    Language["Spanish"] = "Spanish";
    Language["Portuguese"] = "Portuguese";
    Language["Russian"] = "Russian";
    Language["Japanese"] = "Japanese";
    Language["Chinese"] = "Chinese";
    Language["Korean"] = "Korean";
    Language["Turkish"] = "Turkish";
    Language["Arabic"] = "Arabic";
    Language["Hindi"] = "Hindi";
    Language["Indonesian"] = "Indonesian";
    Language["Thai"] = "Thai";
    Language["Vietnamese"] = "Vietnamese";
    Language["Persian"] = "Persian";
    Language["Ukrainian"] = "Ukrainian";
})(Language = exports.Language || (exports.Language = {}));
var LeadPaymentMethodType;
(function (LeadPaymentMethodType) {
    LeadPaymentMethodType["Sepa"] = "sepa";
    LeadPaymentMethodType["Invoice"] = "invoice";
})(LeadPaymentMethodType = exports.LeadPaymentMethodType || (exports.LeadPaymentMethodType = {}));
var TranslatableFieldNamespace;
(function (TranslatableFieldNamespace) {
    TranslatableFieldNamespace["Product"] = "product";
})(TranslatableFieldNamespace = exports.TranslatableFieldNamespace || (exports.TranslatableFieldNamespace = {}));
var TranslatableEntity;
(function (TranslatableEntity) {
    TranslatableEntity["ProductField"] = "product_fields";
    TranslatableEntity["ProductFactor"] = "product_factors";
})(TranslatableEntity = exports.TranslatableEntity || (exports.TranslatableEntity = {}));
var BillingFrequencyUnit;
(function (BillingFrequencyUnit) {
    BillingFrequencyUnit["PerMinute"] = "0_minute";
    BillingFrequencyUnit["Hourly"] = "1_hourly";
    BillingFrequencyUnit["Daily"] = "2_daily";
    BillingFrequencyUnit["Weekly"] = "3_weekly";
    BillingFrequencyUnit["FourWeeks"] = "4_4weeks";
    BillingFrequencyUnit["Monthly"] = "5_monthly";
    BillingFrequencyUnit["Quarterly"] = "6_quarterly";
    BillingFrequencyUnit["HalfYearly"] = "7_half_yearly";
    BillingFrequencyUnit["Yearly"] = "8_yearly";
})(BillingFrequencyUnit = exports.BillingFrequencyUnit || (exports.BillingFrequencyUnit = {}));
var NumberFormatConfigSetting;
(function (NumberFormatConfigSetting) {
    NumberFormatConfigSetting["account"] = "account_number_format_config";
    NumberFormatConfigSetting["policy"] = "policy_number_format_config";
    NumberFormatConfigSetting["claim"] = "claim_number_format_config";
    NumberFormatConfigSetting["customer"] = "customer_number_format_config";
    NumberFormatConfigSetting["lead"] = "lead_number_format_config";
    NumberFormatConfigSetting["invoice"] = "invoice_number_format_config";
})(NumberFormatConfigSetting = exports.NumberFormatConfigSetting || (exports.NumberFormatConfigSetting = {}));
var ActionStatusTransitionRule;
(function (ActionStatusTransitionRule) {
    ActionStatusTransitionRule["Allow"] = "ALLOW";
    ActionStatusTransitionRule["Deny"] = "DENY";
})(ActionStatusTransitionRule = exports.ActionStatusTransitionRule || (exports.ActionStatusTransitionRule = {}));
var EntityTypeStatusTransitionRule;
(function (EntityTypeStatusTransitionRule) {
    EntityTypeStatusTransitionRule["Lead"] = "lead";
    EntityTypeStatusTransitionRule["Policy"] = "policy";
})(EntityTypeStatusTransitionRule = exports.EntityTypeStatusTransitionRule || (exports.EntityTypeStatusTransitionRule = {}));
var ContentDispositionType;
(function (ContentDispositionType) {
    ContentDispositionType["Attachment"] = "attachment";
    ContentDispositionType["Inline"] = "inline";
})(ContentDispositionType = exports.ContentDispositionType || (exports.ContentDispositionType = {}));
